import { Provider } from '@angular/core';
import { MerchantPricingStore } from 'app/store/merchant-pages/merchant-pricing.store';
import { UserAccessPermissionStore } from 'app/store/user-access-permission.store';
import { UserStore } from 'app/store/user.store';
import { RESETTABLE_STORES } from './resettable.token';

// provide the stores need to reset upon logout
export const provideGlobalStores = (): Provider[] => [
    {
        provide: RESETTABLE_STORES,
        useExisting: MerchantPricingStore,
        multi: true,
    },
    {
        provide: RESETTABLE_STORES,
        useExisting: UserAccessPermissionStore,
        multi: true,
    },
    {
        provide: RESETTABLE_STORES,
        useExisting: UserStore,
        multi: true,
    },
    // {
    //     provide: RESETTABLE_STORES,
    //     useExisting: BreadcrumbStore,
    //     multi: true,
    // },
];
